/**
 * Custom Product Media Component
 * Handles hiding thumbnails, disabling slider, and metafield image overrides
 */

class ProductMediaCustom extends HTMLElement {
  constructor() {
    super();
    this.initializeComponent();
  }

  initializeComponent() {
    const hideThumbnails = this.dataset.hideThumbnails === 'true';
    const disableSlider = this.dataset.disableSlider === 'true';
    const overrideImage = this.querySelector('[data-override-image="true"]');

    // Hide thumbnails if requested
    if (hideThumbnails) {
      this.hideThumbnails();
    }

    // Disable slider if requested
    if (disableSlider) {
      this.disableSlider();
    }

    // Handle override image
    if (overrideImage) {
      this.handleOverrideImage(overrideImage);
    }
  }

  hideThumbnails() {
    const thumbnails = this.querySelector('.thumbnail-media--thumbnails');
    if (thumbnails) {
      thumbnails.style.display = 'none';
    }

    // Adjust grid layout for thumbnails
    if (this.classList.contains('media-type-thumbnails')) {
      this.style.gridTemplateColumns = '1fr';
    }
  }

  disableSlider() {
    const swiperWrapper = this.querySelector('.swiper-wrapper');
    const slides = this.querySelectorAll('.swiper-slide');
    const navigation = this.querySelector('.media-slider-navigation');

    if (swiperWrapper) {
      swiperWrapper.style.transform = 'none';
    }

    if (slides) {
      slides.forEach(slide => {
        slide.style.position = 'static';
        slide.style.width = '100%';
        slide.style.marginRight = '0';
        slide.style.visibility = 'visible';
        slide.style.opacity = '1';
        slide.classList.add('swiper-slide-active');
      });
    }

    if (navigation) {
      navigation.style.display = 'none';
    }

    // Disable Swiper if it's initialized
    if (this.swiper) {
      this.swiper.disable();
    }
  }

  handleOverrideImage(overrideSlide) {
    // Make sure the override image is the only visible slide
    const allSlides = this.querySelectorAll('.swiper-slide');
    allSlides.forEach(slide => {
      if (slide !== overrideSlide) {
        slide.style.display = 'none';
      }
    });

    // Show the override slide
    overrideSlide.style.display = 'block';
    overrideSlide.style.visibility = 'visible';
  }

  connectedCallback() {
    // Wait for any existing Swiper initialization to complete
    setTimeout(() => {
      this.initializeComponent();
    }, 100);
  }
}

// Register the custom element
customElements.define('product-media-custom', ProductMediaCustom);

// Also handle existing product-media elements with custom attributes
document.addEventListener('DOMContentLoaded', function() {
  const productMediaWrappers = document.querySelectorAll('[data-hide-thumbnails="true"], [data-disable-slider="true"]');
  
  // First, ensure all slides are visible by default
  const allSlides = document.querySelectorAll('.product-media-slider .swiper-slide');
  allSlides.forEach(slide => {
    slide.style.opacity = '1';
    slide.style.visibility = 'visible';
  });
  
  productMediaWrappers.forEach(wrapper => {
    const hideThumbnails = wrapper.dataset.hideThumbnails === 'true';
    const disableSlider = wrapper.dataset.disableSlider === 'true';
    const overrideImage = wrapper.dataset.overrideImage === 'true';
    const overrideMetafield = wrapper.dataset.overrideMetafield;

    if (hideThumbnails) {
      const thumbnails = wrapper.querySelector('.thumbnail-media--thumbnails');
      if (thumbnails) {
        thumbnails.style.display = 'none';
      }

      const productMedia = wrapper.querySelector('.product-media-slider');
      if (productMedia && productMedia.classList.contains('media-type-thumbnails')) {
        productMedia.style.gridTemplateColumns = '1fr';
      }
    }

    if (disableSlider) {
      const swiperWrapper = wrapper.querySelector('.swiper-wrapper');
      const slides = wrapper.querySelectorAll('.swiper-slide');
      const navigation = wrapper.querySelector('.media-slider-navigation');

      if (swiperWrapper) {
        swiperWrapper.style.transform = 'none';
      }

      if (slides) {
        slides.forEach(slide => {
          slide.style.position = 'static';
          slide.style.width = '100%';
          slide.style.marginRight = '0';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
          slide.classList.add('swiper-slide-active');
        });
      }

      if (navigation) {
        navigation.style.display = 'none';
      }
    }

    if (overrideImage && overrideMetafield && wrapper.dataset.overrideImageUrl) {
      const overrideImageUrl = wrapper.dataset.overrideImageUrl;
      // Replace the first slide's image with the override image
      const firstSlide = wrapper.querySelector('.swiper-slide:first-child');
      if (firstSlide) {
        const img = firstSlide.querySelector('img');
        if (img) {
          img.src = overrideImageUrl;
          img.alt = 'Override Product Image';
        }
        
        // Hide all other slides
        const allSlides = wrapper.querySelectorAll('.swiper-slide');
        allSlides.forEach((slide, index) => {
          if (index > 0) {
            slide.style.display = 'none';
          } else {
            slide.style.display = 'block';
            slide.style.opacity = '1';
          }
        });
        
        // Hide thumbnails when override is active
        const thumbnails = wrapper.querySelector('.thumbnail-media--thumbnails');
        if (thumbnails) {
          thumbnails.style.display = 'none';
        }
        
        // Hide navigation when override is active
        const navigation = wrapper.querySelector('.media-slider-navigation');
        if (navigation) {
          navigation.style.display = 'none';
        }
      }
    }
  });
});
